import React, { FormEvent, useState } from 'react';
import Head from 'next/head';
import apiFetch from ':src/utils/apiFetch';
import Button from ':src/components/Button';

export default function Contact() {
  const [hasError, setHasError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      setIsSubmitting(true);
      await apiFetch('feedback', 'POST', {
        feedback,
      });
      setIsSuccess(true);
    } catch (err) {
      setHasError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Head>
        <title>Contact | frontendeval</title>
        <meta name="description" content="Contact us" />
        <meta property="og:title" content="Contact | frontendeval" />
        <meta property="og:description" content="Contact us" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${process.env.DOMAIN!}/contact`} />
      </Head>
      <div className="container pt-10">
        <form onSubmit={handleSubmit}>
          {!isSuccess && (
            <fieldset id="feedback-fieldset">
              <div className="h3 mb-3">What’s on your mind?</div>
              <div className="lg:grid grid-cols-3">
                <div className="col-span-2">
                  <p className="mb-3 text-opacity-70 text-gray-800">
                    Let us know if you have any feedback about our questions or
                    what you’d like to see on our site in the future.
                  </p>
                  {hasError && (
                    <div className="alert alert-danger">
                      Sorry, something went wrong with your submission. Please
                      try again later!
                    </div>
                  )}
                  <div className="mb-4">
                    <textarea
                      rows={5}
                      className="rounded border border-gray-300 shadow-sm p-6 bg-white w-full focus:outline-none focus:ring focus:border-blue-200"
                      id="content"
                      required
                      value={feedback}
                      onChange={(e) => setFeedback(e.target.value)}
                    />
                  </div>
                  <Button disabled={isSubmitting} type="submit">
                    Submit
                  </Button>
                </div>
              </div>
            </fieldset>
          )}
          {isSuccess && (
            <div>
              <div className="h4 mb-4">Thank you!</div>
              <p>
                We’ll take your feedback into consideration for future
                development.
              </p>
            </div>
          )}
        </form>
      </div>
    </>
  );
}
